import React, { useState, useEffect } from 'react';
import "./SectorFilters.css";
import ComboBox from 'Components/ComboBox/ComboBox';
import OptionsDataByAttributePath from 'Components/Options/optionsData/OptionsDataByAttributePath';
import Panel from 'Components/Panel/Panel';
import RemoveIdsNotFound from 'Components/RemoveIdsNotFound/RemoveIdsNotFound';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';

function SectorFilters({
    onUpdateSectorsLoadedFilter,
    onUpdateIdsSectorCheckBoxSelected,
    onUpdateIdsManagerSelected,
    onUpdateResetFilterSectorsSelected,
    onUpdateResetFilterManagersSelected,
    onUpdateSectorFilterSelected,
    idsSectorCheckBoxSelected,
    resetFilterSectorsSelected,
    resetFilterManagersSelected,
    sectorFilterSelected
}) {
    const [sectors, setSectors] = useState([])

    useEffect(() => {
        const fetchData = async () => {
            const sectors = await ExecuteAxios.api('get', '/sector')
            setSectors(sectors);
        };

        fetchData();
    }, [resetFilterSectorsSelected, resetFilterManagersSelected, sectorFilterSelected])

    useEffect(() => {
        if (resetFilterSectorsSelected) {
            updateSectorList()
        }
    }, [resetFilterSectorsSelected]);

    useEffect(() => {
        updateSectorList()
        onUpdateIdsSectorCheckBoxSelected([])
    }, [sectorFilterSelected])

    useEffect(() => {
        updateSectorList()
    }, []);

    function updateSectorList() {
        onUpdateResetFilterSectorsSelected(false);
        const fetchData = async () => {
            await filterSectors(false);
        };
        fetchData();
        onUpdateResetFilterManagersSelected(true);
    }

    async function filterSectors(resetIdsSelecteds = true) {
        if (resetIdsSelecteds) {
            onUpdateIdsSectorCheckBoxSelected([])
            onUpdateIdsManagerSelected([])
        }
        const parameters = {
            sectorId: sectorFilterSelected
        };
        const sectors = await ExecuteAxios.api('get', `/sector/all-sector`, { params: parameters })
        onUpdateSectorsLoadedFilter(sectors)
        RemoveIdsNotFound.remove(sectors, onUpdateIdsSectorCheckBoxSelected, idsSectorCheckBoxSelected)
    }

    const sectorOptions = OptionsDataByAttributePath(sectors, ['description'], null, true)

    const PanelFilterStyle = {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-evenly'
    };

    const PanelButtonsFilterStyle = {
        display: 'flex',
        flexDirection: 'row'
    };

    return (
        <>
            <Panel style={PanelFilterStyle}
                titlePage={'Filtros Setor'}
                canViewCRUD={true}
            >
                <div id='first-colum-filter-sectors'>
                    <Panel style={PanelButtonsFilterStyle}>
                        <div id='sector-filter'>
                            <span className='span-sector-filter'>Setor</span>
                            <ComboBox setAttribute={onUpdateSectorFilterSelected}
                                optionsData={sectorOptions}
                                value={sectorFilterSelected}
                                defaultValue={sectorFilterSelected}
                                style={{ width: '150px', cursor: 'pointer' }}
                            />
                        </div>
                    </Panel>
                </div>
            </Panel >
        </>

    );
};

export default SectorFilters;